import { Layout } from '@roc/feature-app-core';
import { EmbeddedFrameBoundaries } from '@roc/ui';
import { BorrowerInfoCardCustomTheme } from './components/borrowerInfoCardCustomTheme';
import { BorrowerTrackRecordStore } from '@roc/feature-borrowers';
// New isolated Track Record UI (does not affect other portals).
import {
  TrackRecordLineItemV2 as TrackRecordLineItem,
  BorrowerTrackRecordVerification,
} from '@roc/feature-track-record-v2';

interface BorrowerTrackRecordLineItemComponentProps {
  store: BorrowerTrackRecordStore;
  borrowerId?: string;
  loanTaskId?: string;
}

export const BorrowerTrackRecordLineItemComponent = ({ store, borrowerId, loanTaskId }: BorrowerTrackRecordLineItemComponentProps) => {

  if (!borrowerId || !loanTaskId) {
    return (<></>);
  }
  let parsedLoanTaskId;
  let parsedBorrowerId;
  try {
    parsedLoanTaskId = loanTaskId ? parseInt(loanTaskId) : null;
    parsedBorrowerId = borrowerId ? parseInt(borrowerId) : null;
  } catch { }

  if (!parsedBorrowerId || !parsedLoanTaskId) {
    return (<></>);
  }

  store.getDocument(loanTaskId);
  store.internal = true;

  const onClose = () => {
    // Target the embedding parent's origin explicitly instead of '*' so the
    // message can't be intercepted by an unexpected embedding context.
    const parentOrigin = window.location.ancestorOrigins?.[0] || window.location.origin;
    window.parent.postMessage('saved-success', parentOrigin);
  };
  // store.document loads asynchronously, so fall back to the prop and skip when there is no id.
  const onDocUploadCallback = () => {
    const id = store.document?.loanTaskId ?? parsedLoanTaskId;
    if (id) {
      store.getDocument(id);
    }
  };

  return (
    <Layout>
      <BorrowerInfoCardCustomTheme>
        <EmbeddedFrameBoundaries>
          <TrackRecordLineItem
            store={store}
            borrowerId={parsedBorrowerId}
            onClose={onClose}
          >
            <BorrowerTrackRecordVerification
              token=''
              isInternal={true}
              isTpoFlow={false}
              showBanner={false}
              store={store}
              onClose={onClose}
              onSaveCompleted={onClose}
              borrowerId={parsedBorrowerId}
              onDocUploadCallback={onDocUploadCallback}
            />
          </TrackRecordLineItem>
        </EmbeddedFrameBoundaries>
      </BorrowerInfoCardCustomTheme>
    </Layout>
  );
};
